import React from 'react';
import UploadComponent from './index';
import { Upload, Icon, Button } from 'antd';
import './multipleImg.less';
class MultipleUploadComponent extends UploadComponent {
  static getDerivedStateFromProps(nextProps) {
    // Should be a controlled component.
    if ('value' in nextProps) {
      return {
        ...(nextProps.value || {})
      };
    }
    return null;
  }
  constructor() {
    super();
    this.state = {
      fileUrl: ''
    };

    this.uploadOptions = {
      ...this.uploadOptions,
      listType: 'picture',
      onChange: this.handleChange,
      multiple: true,
      className: 'upload-list-inline',
      onRemove: this.onRemove
    };
  }
  onRemove = file => {
    const currentUrl = file.response ? file.response.url : file.url;
    const arr =
      this.state.fileUrl.length > 0 ? this.state.fileUrl.split(',') : [];
    const fileUrlArr = arr.filter(item => {
      return item !== currentUrl;
    });
    const fileUrl = fileUrlArr.join(',');
    this.setState({ fileUrl: fileUrl });
    this.inputHandleChange({ fileUrl: fileUrl });
  };
  handleChange = info => {
    console.log(info);
    this.uploadChange(info).then(url => {
      const arr =
        this.state.fileUrl.length > 0 ? this.state.fileUrl.split(',') : [];
      arr.push(url);
      const fileUrl = arr.join(',');
      console.log(arr);
      this.setState({ fileUrl: fileUrl });
      this.inputHandleChange({ fileUrl: fileUrl });
    });
  };
  inputHandleChange(value) {
    this.triggerChange(value);
  }
  triggerChange = changedValue => {
    const onChange = this.props.onChange;
    if (onChange) {
      onChange(Object.assign({}, this.state, changedValue));
    }
  };
  render() {
    const fileLists =
      this.state.fileUrl.length > 0
        ? this.state.fileUrl.split(',').map((item, index) => {
            const file = {
              uid: index,
              name: item,
              url: item,
              thumbUrl: item,
              status: 'done'
            };
            return file;
          })
        : [];
    this.uploadOptions.defaultFileList = [...fileLists];
    return (
      <div>
        {(this.props.actionType === 'add' ||
          (this.props.actionType === 'update' && this.props.loaded)) && (
          <Upload {...this.uploadOptions}>
            <Button>
              <Icon type="upload" /> Upload
            </Button>
          </Upload>
        )}
        <input
          type="hidden"
          value={this.state.fileUrl}
          onChange={this.inputHandleChange}
        />
      </div>
    );
  }
}

export default MultipleUploadComponent;
